const messages = {
  en: {
    faqTitle: 'Popular FAQs',
    faqSub: 'Here are the most frequently accessed FAQs',
    tutorialTitle: 'Popular Tutorials',
    tutorialSub:
      'Choose a tutorial and follow the interactive steps to learn how to use your device.',
    guideTitle: 'Popular Troubleshooting Guides',
    guideSub:
      'Having problems? Here are some troubleshooting guides to help you solve your issue.',
    videoTitle: 'Popular Videos',
    videoSub:
      'Maybe a self-help video is just what you need to learn about your phone.'
  },
  'es-ud': {
    faqTitle: 'FAQs Populares',
    faqSub: 'Aquí tenemos algunas FAQs populares',
    tutorialTitle: 'Tutoriales Populares',
    tutorialSub:
      '¿Tiene un nuevo teléfono, o quiere convertirse en usuario avanzado? Elija un equipo y siga los pasos interactivos para aprender a usar el dispositivo.',
    guideTitle: 'Guías de Resolución de Problemas Populares',
    guideSub:
      '¿Tiene algún problema? Aquí tenemos algunas guías de solución de problemas para ayudarle.',
    videoTitle: 'Videos Populares',
    videoSub:
      'Tal vez un video de autoayuda es justo lo que necesita para aprender sobre el equipo.'
  },
  es: {
    faqTitle: 'FAQs Populares',
    faqSub: 'Aquí tenemos algunas FAQs populares',
    tutorialTitle: 'Tutoriales Populares',
    tutorialSub:
      '¿Tienes un nuevo teléfono, o quieres convertirte en usuario avanzado? Elige un equipo y sigue los pasos interactivos para aprender a usar el dispositivo.',
    guideTitle: 'Guías de Resolución de Problemas Populares',
    guideSub:
      '¿Tienes algún problema? Aquí tenemos algunas guías de solución de problemas para ayudarte.',
    videoTitle: 'Videos Populares',
    videoSub:
      'Tal vez un video de autoayuda es justo lo que necesitas para aprender sobre el equipo.'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/GettingStarted/messages.js